import type { TranslationMessages } from '../../types';

export const pin: TranslationMessages = {
  pin_tab: 'Pin tab',
  unpin_tab: 'Unpin tab',
  pinned: 'Pinned',
  pin: 'Pin',
};
